module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-vertical-top-mask.94070aec.png";